var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    ref: "wEditor",
    staticClass: "wEditor"
  }), _c('wording-modal', {
    ref: "wordingModal",
    attrs: {
      "title": _vm.wordingTitle,
      "fetch-wording": _vm.wordingFetcher
    },
    on: {
      "insert": _vm.handleInsertWording
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }